import { Injectable } from '@angular/core';
import { ParentService } from '../pages/A2-utils/ParentClass/ParentService';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import {constant} from '../app.constants';

@Injectable()
export class EscalationService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  getTripsEscalations() {
    const url = constant.URL_TRIPS_ESCALATION;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/escalation.service.ts